import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { SelectAdoProject } from './SelectAdoProjectExtension';

export const SelectAdoProjectFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'SelectAdoProject',
    component: SelectAdoProject,
  }),
);
